<template>
    <div class="container pt-5" v-if="loadingStates.domains || domainChecks.length > 0">
        <div class="row">
            <div class="col-4 col-sm-1 mt-5 mb-3"><div class="topic-separator w-100"></div></div>
            <div class="col-12 mb-3">
              <h2 class="color-black">3. Results</h2>
            </div>
        </div>
        <div class="row">
            <table class="table">
                <tr v-bind:key="check.name" v-for="check in domainChecks">
                    <td class="name-col">{{check.name}}</td>
                    <td class="d-sm-flex justify-content-sm-between">
                        <LinkedPill class="mr-3 m-sm-0 d-inline-block" :available="check.tldsCheck['com']" available-icon="cart" unavailable-icon="cross" text=".com" :link="buildLink(check.name, 'com')" :link-active="check.tldsCheck['com']"/>
                        <LinkedPill class="mr-3 m-sm-0 d-inline-block" :available="check.tldsCheck['co']" available-icon="cart" unavailable-icon="cross" text=".co" :link="buildLink(check.name, 'co')" :link-active="check.tldsCheck['co']"/>
                        <LinkedPill class="mr-3 mt-3 m-sm-0 d-inline-block" :available="check.tldsCheck['io']" available-icon="cart" unavailable-icon="cross" text=".io" :link="buildLink(check.name, 'io')" :link-active="check.tldsCheck['io']"/>
                        <span class="mr-3 mt-3 m-sm-0 d-inline-block"
                              v-on:click="checkDoubleMeaning(check.name)">
                          <LinkedPill :available="!doubleMeaningChecks[check.name]"
                                  :active="typeof(doubleMeaningChecks[check.name]) !== 'undefined' && doubleMeaningChecks[check.name] !== null"
                                  text="check meaning"
                                  available-text="no meaning"
                                  unavailable-text="meaning"
                                  unavailable-icon="external_link"
                                  :outlined="true"
                                  :link="`https://www.urbandictionary.com/define.php?term=${check.name}`"
                                  :link-active="doubleMeaningChecks[check.name]"/>
                        </span>
                    </td>
                </tr>
            </table>
        </div>
        <div class="row justify-content-center">
          <div class="col-4 col-sm-2 mb-3" v-if="loadingStates.domains">
            <Loading/>
          </div>
          <div class="col">
            <button v-if="!loadingStates.domains" v-on:click="sendWords" class="btn btn-block btn-primary"><SvgIcon :icon="'plus'" class="icon icon-refresh"/></button>
          </div>
        </div>
    </div>
</template>

<script>
    import Loading from './Loading';
    import {GET_DOUBLEMEANING_CHECK, SEND_WORDS} from '@/store/action-types';
    import {mapState} from 'vuex';
    import LinkedPill from '@/components/LinkedPill';
    import SvgIcon from '@/components/SvgIcon';

    export default {
        name: "Results",
        components: {
            Loading,
            LinkedPill,
            SvgIcon
        },
        computed: {
            ...mapState([
                'domainChecks',
                'doubleMeaningChecks',
                'loadingStates'
            ])
        },
        methods : {
            checkDoubleMeaning(name) {
                if (typeof(this.$store.state.doubleMeaningChecks[name]) === 'undefined' || this.$store.state.doubleMeaningChecks[name] === null) {
                    this.$store.dispatch(GET_DOUBLEMEANING_CHECK, name);
                }
            },
            buildLink(name, extension) {
              return `https://namecheap.pxf.io/c/2589880/386170/5618?u=https%3A%2F%2Fwww.namecheap.com%2Fdomains%2Fregistration%2Fresults.aspx%3Fdomain%3D${name}.${extension}`
            },
            sendWords () {
              this.$store.dispatch(SEND_WORDS);
            },
        }
    }
</script>

<style scoped lang="scss">
    .icon-tick {
        stroke: white;
    }
    .icon-cross {
        stroke: white;
    }
    .icon-refresh {
      stroke: $black;
      width: 2rem;
      height: 2rem;
    }
    .result-pill.available {
        background-color: $green;
    }
    .result-pill:not(available) {
        background-color: $red;
    }
    .name-col {
        font-weight: bold;
        width: 6rem;
    }
</style>
